import { hotTickerList } from "@/mocks/portal";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* 装饰背景 */}
      <div className="absolute inset-0 -z-10 bg-background-50" />
      <div className="absolute -right-24 -top-24 -z-10 h-80 w-80 rounded-full bg-accent-100/60 blur-3xl" />
      <div className="absolute -left-24 top-40 -z-10 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />

      <div className="mx-auto max-w-7xl px-4 pb-12 pt-12 md:px-6 md:pt-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-primary-600 ring-1 ring-background-200">
              <i className="ri-radar-line" />
              实时热度追踪 · 每日更新
            </span>
            <h1 className="mt-5 font-heading text-4xl font-bold leading-tight text-foreground-950 md:text-5xl">
              别错过每一个<span className="text-primary-500">热点爆点</span>
              <br />
              一站式吃瓜不迷路
            </h1>
            <p className="mt-5 max-w-xl text-base leading-7 text-foreground-600">
              曝光导航聚合综艺、影视、音乐、时尚等圈内最新动态，以滚动更新的热门排行、
              深度整理的内容专题，帮你高效掌握当下热度，不错过任何精彩瞬间。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#today"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-flashlight-fill" />
                查看今日更新
              </a>
              <a
                href="/rankings"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                <i className="ri-fire-fill" />
                热门排行
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-6">
              {[
                { num: "3200+", label: "热点资讯" },
                { num: "150+", label: "内容专题" },
                { num: "40万+", label: "累计阅读" },
              ].map((s) => (
                <div key={s.label} className="flex items-center gap-6">
                  <div>
                    <p className="font-heading text-2xl font-bold text-foreground-950">{s.num}</p>
                    <p className="text-xs text-foreground-600">{s.label}</p>
                  </div>
                  {s.label !== "累计阅读" && <span className="h-8 w-px bg-background-200" />}
                </div>
              ))}
            </div>
          </div>

          {/* 热点滚动卡 */}
          <div className="lg:col-span-5">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                  <span className="flex h-6 w-6 items-center justify-center rounded bg-primary-500 text-background-50">
                    <i className="ri-fire-line text-xs" />
                  </span>
                  此刻正在热议
                </h2>
                <span className="flex items-center gap-1.5 text-xs text-foreground-600">
                  <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
                  实时滚动
                </span>
              </div>
              <ul className="mt-4 space-y-3">
                {hotTickerList.map((t, i) => (
                  <li
                    key={t}
                    className="flex items-start gap-3 rounded-lg bg-background-100 px-3 py-2.5 transition-colors hover:bg-background-200/60"
                  >
                    <span className="mt-0.5 font-heading text-lg font-bold text-primary-400">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 text-sm font-medium leading-5 text-foreground-800 line-clamp-1">
                      {t}
                    </span>
                    <i className="ri-arrow-right-up-line mt-0.5 text-accent-600" />
                  </li>
                ))}
              </ul>
              <a
                href="/rankings"
                className="mt-4 flex items-center justify-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700"
              >
                查看完整排行 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}